import { render } from "./SaveEmployeeReportTo.vue?vue&type=template&id=27f7283d"
import script from "./SaveEmployeeReportTo.vue?vue&type=script&lang=js"
export * from "./SaveEmployeeReportTo.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__